// import {
//     generateConfig,
//     getApiBaseUrl,
//     login,
//     ROOT_CONFIG_LOCAL_STORAGE_KEY,
//     USER_ROLES,
// } from '@ptml/root-config';
import { registerApplication, start } from 'single-spa';
import { constructApplications, constructLayoutEngine, constructRoutes } from 'single-spa-layout';
import { initializeImportMap } from './import-map-helper';
import { type LoadAppFunction } from './partstrader-root.types'

// Register web components
import './web-components';

/**
 * Initializes the root config settings with the provided user data.
 * @param userData The user data used for initialization.
 */
const fetchLayout = async (): Promise<string> => {
    const response = await fetch(new URL('microfrontend-layout.html', import.meta.url));
    return await response.text();
};

const initialize = async (): Promise<void> => {
    const microfrontendLayout = await fetchLayout();
    const data = {
        loaders: {},
        props: {
            config: { baseUrl: '/' },
            handleError: (error: Error) => {
                console.error('Error in root', error);
            },
        },
    };

    const { loadApp } = initializeImportMap();

    const typedLoadApp: LoadAppFunction = loadApp;

    const routes = constructRoutes(microfrontendLayout, data);
    const applications = constructApplications({
        routes,
        loadApp: typedLoadApp,
    });
    const layoutEngine = constructLayoutEngine({
        routes,
        applications,
    });

    for (const app of applications) {
        registerApplication(app);
    }
    layoutEngine.activate();
    start();
};

// oxlint-disable-next-line unicorn/prefer-top-level-await
void initialize();

// oxlint-disable-next-line unicorn/prefer-top-level-await -- Continuation of promise chain for legacy target compatibility
// void login()
//     .then(async (userData) => {
//         if (!userData) {
//             if (typeof globalThis !== 'undefined') {
//                 globalThis.location.href = `${getApiBaseUrl()}/fss/insurer/auth/login?returnUrl=${globalThis.location.href}`;
//             }
//             return;
//         }

//         const insurerRoles = new Set(USER_ROLES);
//         if (userData.roles.some((role) => insurerRoles.has(role))) {
//             // prettier-ignore -- single-line assertion for clarity
//             const environmentObject = (import.meta as unknown as { env?: Record<string, unknown> })
//                 .env;
//             const ldKeyRaw = environmentObject?.VITE_LaunchDarkly_insurer_vnext_Client_Sdk_Key;
//             const ldKey = typeof ldKeyRaw === 'string' ? ldKeyRaw : '';
//             const config = await generateConfig(userData, ldKey);

//             const { user = null } = config;

//             if (typeof globalThis !== 'undefined') {
//                 globalThis.localStorage.setItem(
//                     ROOT_CONFIG_LOCAL_STORAGE_KEY,
//                     JSON.stringify(config),
//                 );
//                 globalThis.dispatchEvent(
//                     new StorageEvent('local-storage', {
//                         key: ROOT_CONFIG_LOCAL_STORAGE_KEY,
//                     }),
//                 );
//             }

//             // await LaunchDarklyClientSide({
//             //     envKey: config.launchDarklyClientId,
//             //     context: {
//             //         kind: 'user',
//             //         key: user ? `c-${user.company_displayid}` : '',
//             //     },
//             // });

//             if (user?.principal_accountid && window.newrelic) {
//                 window.newrelic?.setUserId(user?.principal_accountid ?? null);
//             }

//             if (typeof document !== 'undefined' && document.body.hasAttribute('inert')) {
//                 document.body.removeAttribute('inert');
//             }
//         }
//     })
//     .catch((error: unknown) => {
//         console.error('Error during login initialisation', error);
//     });
